<template>
  <div class="app-container">
    <div class="filter-container">
      <el-date-picker class="filter-item" v-model="search.day" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="option.picker"></el-date-picker>
      <el-select class="filter-item" v-model="search.status" clearable placeholder="发生的状态">
        <el-option v-for="kv in option.status" :key="kv.k" :label="kv.v" :value="kv.k"></el-option>
      </el-select>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>

      <el-button class="filter-item" type="primary" icon="el-icon-s-flag" plain @click="doExport">查询数据导出</el-button>
      <el-button class="filter-item" type="primary" icon="el-icon-download" plain @click="doExportAll">在库数据导出</el-button>
    </div>

    <el-table class="tbl" v-loading="loading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="条码号" prop="sn" fixed align="center" width="120px"></el-table-column>
      <el-table-column label="发生时间" prop="time" align="center" width="140px"></el-table-column>
      <el-table-column label="状态变化" align="center" width="120px">
        <template slot-scope="props">
          {{ props.row.prev | statusFilter }} <i class="el-icon-right"></i> {{ props.row.state | statusFilter }}
        </template>
      </el-table-column>
      <el-table-column label="当前状态" align="center" width="80px">
        <template slot-scope="props">
          <span :class="'w' + props.row.status">{{ props.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="量器属性" align="center">
        <el-table-column label="规格" prop="spec" align="center" width="150px"></el-table-column>
        <el-table-column label="内部编号" prop="inno" align="center" width="120px"></el-table-column>
        <el-table-column label="检定时间" prop="day" align="center" width="100px"></el-table-column>
        <el-table-column label="年限" align="center" width="100px">
          <template slot-scope="props">
            {{ props.row.life | lifeFilter }}
          </template>
        </el-table-column>
        <el-table-column label="检定人" prop="user" align="center" width="100px"></el-table-column>
        <el-table-column label="级别" prop="level" align="center" width="100px"></el-table-column>
        <el-table-column label="分配组" prop="team" align="center" width="100px"></el-table-column>
        <el-table-column label="报废原因" prop="scrap_why"></el-table-column>
        <el-table-column label="报废人" prop="scrap_who"></el-table-column>
        <el-table-column label="报废时间" prop="scrap_day" width="150px"></el-table-column>
      </el-table-column>
      <el-table-column label="操作员" prop="uid" align="center" width="140px"></el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

  </div>
</template>

<script>
import waves from '@/directive/waves'

const option = {
  status: [{k: 1, v: '入库'}, {k: 2, v: '送检'}, {k: 3, v: '复检'}, {k: 4, v: '报废'}],
  life: [{k: 1, v: '一年'}, {k: 2, v: '两年'}, {k: 3, v: '三年'}],
  picker: {
    shortcuts: [{
        text: '今天',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          picker.$emit('pick', [start, end])
        }
      }, {
        text: '最近一周',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      }, {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      }, {
        text: '最近两个月',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 60)
          picker.$emit('pick', [start, end])
        }
    }]
  }
}

export default {
  name: 'Stats',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      if (key === 0) {
        return '闲置'
      }
      let d = option.status.find(row => row.k == key)
      return d? d.v: '-'
    },
    lifeFilter(key) {
      let d = option.life.find(row => row.k == key)
      return d? d.v: '-'
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      loading: false,
      search: {
        page: 1,
        size: 12,
        day: [],
        status: null
      },
      option: option
    }
  },
  methods: {
    getList() {
      const _t = this
      _t.loading = true
      _t.$http.post('/api/ware/stats/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.loading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.loading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    doExport() {
      const _t = this
      if (!_t.search.day || _t.search.day.length != 2) {
        _t.$message.error('请选择时间');
        return;
      }
      if (!_t.search.status) {
        _t.$message.error('请选择状态');
        return;
      }
      _t.$confirm('按查询条件导出数据, 是否继续?', '提示').then(() => {
        _t.loading = true
        _t.$http.post('/api/ware/export/', _t.search).then(resp => {
          if (resp.code === 0) {
            _t.$notify({title: '文档密码', message: '密码: ' + resp.data.pwd + ' 仅显示一次请牢记', duration: 0})
            window.open(resp.data.url, '_self')
          }
          setTimeout(() => {
            _t.loading = false
          }, 500)
        }).catch(() => {
          setTimeout(() => {
            _t.loading = false
          }, 500)
        })
      })
    },
    doExportAll() {
      const _t = this
      _t.$confirm('导出在库的所有数据, 是否继续?', '提示').then(() => {
        _t.loading = true
        _t.$http.post('/api/ware/export-all/').then(resp => {
          if (resp.code === 0) {
            _t.$notify({title: '文档密码', message: '密码: ' + resp.data.pwd + ' 仅显示一次请牢记', duration: 0})
            window.open(resp.data.url, '_self')
          }
          setTimeout(() => {
            _t.loading = false
          }, 500)
        }).catch(() => {
          setTimeout(() => {
            _t.loading = false
          }, 500)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tbl {
  .w1 {
    color: #67C23A;
  }
  .w2 {
    color: #E6A23C;
  }
  .w3 {
    color: #409EFF;
  }
  .w4 {
    color: #909399;
  }
}
</style>
